import { ANYWHERE_PLACE_ID } from 'constants/search'
import { getSupportedDestinationIdFromPathname } from 'home/getSupportedDestinationFromPathname'

function isAnywhereOrEmptyPlaceIds(placeIds: Array<string> | undefined): boolean {
  return !placeIds?.length || (placeIds.length === 1 && placeIds[0] === ANYWHERE_PLACE_ID)
}

function isAnywhereOrEmptyDestinationId(destinationId: string | undefined): boolean {
  return !destinationId || destinationId === ANYWHERE_PLACE_ID
}

/**
 * Scopes an unscoped hero-carousel filter set to the destination landing URL.
 * Leaves filters alone when CMS already set a concrete place or destinationId.
 */
export function applyDestinationLandingPlaceFilters(
  filters: App.OfferListFilters,
  pathname: string,
): App.OfferListFilters {
  const destinationId = getSupportedDestinationIdFromPathname(pathname)
  if (
    !destinationId
    || !isAnywhereOrEmptyPlaceIds(filters.placeIds)
    || !isAnywhereOrEmptyDestinationId(filters.destinationId)
  ) {
    return filters
  }

  return {
    ...filters,
    destinationId,
    placeIds: [destinationId],
  }
}
